import ElementConfig from '../classes/definitions/formItem/ElementConfig';
import FormItem from '../classes/definitions/formItem/FormItem';
var adjustmentLevelSchema = {
    from_price: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
            step: "0.05",
            min: "0"
        }),
        elementType: 'input',
        label: 'Начална сума',
        value: 0,
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валидна стойност',
    }),
    to_price: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
            step: "0.05",
            min: "0"
        }),
        elementType: 'input',
        label: 'Крайна сума',
        value: 0,
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валидна стойност',
    }),
    percent_adjustment: new FormItem({
        elementConfig: new ElementConfig({
            className: 'form-control',
            type: 'number',
            max: '100',
            min: "0"
        }),
        elementType: 'input',
        label: 'Процентна отстъпка',
        value: 0,
        validation: {
            required: true
        },
        valid: false,
        touched: false,
        errorMsg: 'Моля, въведете валидна стойност',
    }),
};
export default adjustmentLevelSchema;



//////////////////
// WEBPACK FOOTER
// ./src/schemas/adjustmentLevelSchema.ts
// module id = 288
// module chunks = 0